// extracted by mini-css-extract-plugin
export default {"root":"shop_root__M4NGh"};